module.exports = __webpack_public_path__ + "static/img/passion-03.0ce965d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-03.png
// module id = 128
// module chunks = 0